import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { referralGetSuccess } from '@collections/referral/referral.action';
import { Referral } from '@shared/models';

export type ReferralState = EntityState<Referral>;

export const referralsAdapter: EntityAdapter<Referral> = createEntityAdapter<Referral>({});

export const initialState: ReferralState = referralsAdapter.getInitialState({});

const reducer = createReducer(
  initialState,
  on(referralGetSuccess, (state, { referral }) => referralsAdapter.upsertOne(referral, state)),
);

export function referralReducer(state: ReferralState, action) {
  return reducer(state, action);
}
